import { render, staticRenderFns } from "./SharedOwnership.vue?vue&type=template&id=0aa0cb23"
import script from "./SharedOwnership.vue?vue&type=script&lang=js"
export * from "./SharedOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports